import AboutUs from './aboutUs';
import Footer from './footer';
import Header from './header';
import ReviewsComponent from './review';
import Services from './service';
// import { motion } from 'framer-motion';
import {  motion } from 'framer-motion';
export default function Home(){
    
    return <>
    <motion.div
  initial={{ opacity: 0, y: 20 }} // Start hidden and 20px down
  animate={{ opacity: 1, y: 0 }}  // Animate to visible and original position
  transition={{ duration: 0.7 }}   // Animation duration
>
<div className="main-section" id='home'>
        <Header/>
        <img src={require('../images/الرئيسية.jpg')} alt='logoimage'/>
        


    </div>
</motion.div>

<AboutUs/>

    
    <Services/>
    <div className='container' id='reviews'>
    <ReviewsComponent placeId="https://maps.app.goo.gl/bBb1gywSgZybCx1a9" />
    </div>
    <Footer/>
    </>
}